import type { ComponentProps } from "react";
import { Link } from "react-router-dom";
import { tv } from "tailwind-variants";
import { t } from "ttag";

import { PHONE_NUMBERS } from "@/shared/models";
import { PhoneIcon } from "@/shared/ui";

const styles = tv({
  slots: {
    contact: "gap-1 text-sm text-neutral-600 [&>a]:text-neutral-800",
    button:
      "flex size-9 items-center justify-center rounded-lg border border-neutral-300",
  },
});

const { contact, button } = styles();

export const PhoneContact = ({ className, ...props }: ComponentProps<"p">) => {
  return (
    <p className={contact({ className })} {...props}>
      {t`Call us`}{" "}
      <Link to={PHONE_NUMBERS.CUSTOMER_SUPPORT.TEL_HREF}>
        {PHONE_NUMBERS.CUSTOMER_SUPPORT.NUMBER}
      </Link>
    </p>
  );
};

export const PhoneButton = ({
  className,
  ...props
}: Omit<ComponentProps<typeof Link>, "to">) => {
  return (
    <Link
      to={PHONE_NUMBERS.CUSTOMER_SUPPORT.TEL_HREF}
      className={button({ className })}
      {...props}
    >
      <PhoneIcon className="size-3 text-neutral-700" />
    </Link>
  );
};
